module.exports = __webpack_public_path__ + "media/34.577fbcc9.mp3";